import React from "react";
import { BsFillStarFill, BsStarHalf, BsStar } from "react-icons/bs";
import css from './section.module.css'
const Star = ({ stars }) => {
  // Array.form will return an array of five element using its callback ftn
  const ratingStar = Array.from({ length: 5 }, (elem, index) => {
    // debugger; // use this command for debugging
    return (
      <span key={index}>
        {stars >= index + 1 ? (
          <BsFillStarFill className={css.star} />
        ) : stars >= index + 0.5 ? (
          <BsStarHalf className={css.star} />
        ) : (
          <BsStar className = {css.star}  />
        )}
      </span>
    );
  });

  return (
      <div className={css.star_style}>
        {ratingStar}
      </div>
  );
};

export default Star;